import { Grid, Typography as Type } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const MenuDetails = () => {
  const location = useLocation();
  const { menuId } = location?.state || {};
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/menu", text: "Menu" },
      {
        key: "3",
        href: `/menu`,
        text: `${menuId?.menu_title} Details`,
      },
    ]);
  }, [menuId]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 85%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          display: "grid",
          gridTemplateRows: "15% 80%",
          backgroundColor: "#F0F5FF",
        }}
      >
        <div style={{ backgroundColor: "white", height: "7vh", width: "100%" }}>
          <TopNavBar />

          <div
            style={{
              marginLeft: "30px",
              justifyContent: "flex-start",
              display: "flex",
            }}
          >
            <h2>View Menu</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer
          component={Paper}
          style={{
            width: "75vw",
            border: "1px solid #ccc",
            borderRadius: "15px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            marginTop: "40px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginLeft: "30px",
          }}
        >
          <h1 style={mainHeadingStyle}>Menu Information</h1>

          <hr />
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Menu Title
              </Type>

              <Type style={inputTextStyle}>
                {menuId?.menu_title}
              </Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Menu Slug
              </Type>
            
              <Type style={inputTextStyle}>
                {menuId?.menu_slug}
              </Type>
            </Grid>
          </Grid>
        </TableContainer>
      </div>
    </div>
  );
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
};

export default MenuDetails;
